﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
const OperationalContextClientConfiguration_1 = require("../OperationalContextClientConfiguration");
class LoginClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    login(login, password) {
        return this.client.apiLoginPost(login, password);
    }
    renewToken() {
        if (OperationalContextClientConfiguration_1.OperationalContextClientConfiguration.getToken()) {
            return this.client.apiLoginRenewPost();
        }
        console.warn(`[${new Date()}] LoginClient.renewToken() => No token found`);
        return Promise.resolve('');
    }
}
exports.LoginClient = LoginClient;
//# sourceMappingURL=LoginClient.js.map